export default __webpack_public_path__ + "static/media/938cd5f4e13dfbe3c8105bdbf232152e.svg";